import { companyPaymentGatewaysConstants } from '_store/_constants';

import alertActionCreators from '../alert.actions';
import service from '../../../services/companyPaymentGateways.service';

const createPaymentGateway = (paymentGatewayData, callback, errorCallback) => {
  return dispatch => {
    dispatch(request(paymentGatewayData));

    service
      .createPaymentGateway(paymentGatewayData)
      .then(response => {
        const createdGateway = response.data;
        dispatch(success(createdGateway));
        dispatch(alertActionCreators.success('Gateway de pagamento criado com sucesso'));

        if (callback) {
          callback(createdGateway);
        }
      })
      .catch(error => {
        dispatch(failure(error));

        if (errorCallback) {
          errorCallback();
        }
      });
  };

  function request(paymentGateway) {
    return {
      type: companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_CREATE_REQUEST,
      payload: { paymentGateway },
    };
  }
  function success(paymentGateway) {
    return {
      type: companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_CREATE_SUCCESS,
      payload: paymentGateway,
    };
  }
  function failure(error) {
    return {
      type: companyPaymentGatewaysConstants.COMPANY_PAYMENT_GATEWAY_CREATE_FAILURE,
      payload: { error },
    };
  }
};

export default createPaymentGateway;
